import axios from "axios";
import env from "../environments/env";
import "./interceptor";

export const Get = async (url, params, config) => {
  try {
    const res = await axios.get(`${env.API_URL}/${url}`, {
      params,
      ...config,
      // handle timeout errors
      timeout: 60000,
      timeoutErrorMessage: "timeout",
    });
    return res.data;
  } catch (err) {
    throw handleErrorResponse(err);
  }
};

export const Post = async (url, body, config) => {
  try {
    const res = await axios.post(`${env.API_URL}/${url}`, body, config);
    return res.data;
  } catch (err) {
    throw handleErrorResponse(err);
  }
};

export const Put = async (url, body, config) => {
  try {
    const res = await axios.put(`${env.API_URL}/${url}`, body, config);
    return res.data;
  } catch (err) {
    throw handleErrorResponse(err);
  }
};

export const Delete = async (url, body, config) => {
  try {
    const res = await axios.delete(`${env.API_URL}/${url}`, body, config);
    return res.data;
  } catch (err) {
    throw handleErrorResponse(err);
  }
};

const handleErrorResponse = (err) => {
  console.log(err);
  const { response = {}, message, code } = err;
  const { status = null, statusText = null, data = {} } = response;
  let error = {
    status,
    statusText,
    data,
  };

  // timeout
  if (message === "timeout" || code === "ECONNABORTED") {
    error = {
      ...error,
      status: 503,
      error: "timeout",
    };
    return error;
  }

  // CORS or 403
  if (!status) {
    error = {
      ...error,
      error: "forbidden",
      status: 403,
    };
    return error;
  }

  if (message === "Network Error") {
    error = {
      ...error,
      error: "network",
    };
    return error;
  }

  if (status === 401) {
    error = {
      ...error,
      error: "unauthorized",
    };
    return error;
  }

  if (status === 400) {
    error = {
      ...error,
      error: "badrequest",
    };
    return error;
  }

  error = {
    ...error,
    error: "server",
  };

  return error;
};
